import { connect } from "react-redux";

import App from "../components";

export default connect(null, null)(App);
